

































import {reactive, defineComponent} from '@vue/composition-api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import BetaAgreement from '@/components/Docs/BetaAgreement.md'
import {userStore} from '@/store'
import {projectNotificationsUnsubscribe} from '@/store/modules/project'
import {shotsNotificationsUnsubscribe} from '@/store/modules/shot'

const components = {VuePerfectScrollbar, BetaAgreement,}

export default defineComponent({
  name: 'BetaAgreementModal',
  components,
  setup(props, {root}) {
    const state = reactive({
      loading: false,
    })

    const acceptAgreement = async () => {
      state.loading = true
      await userStore.setAgreementOK('beta')
      state.loading = false
      await root.$router.push({name: 'shot'})
    }

    const rejectAgreement = async () => {
      if (projectNotificationsUnsubscribe)
        projectNotificationsUnsubscribe()
      if (shotsNotificationsUnsubscribe)
        shotsNotificationsUnsubscribe()
      await userStore.logoutUser()
      await root.$router.push({name: 'login'})
    }

    return {state, acceptAgreement, rejectAgreement}
  }
})
